import React, { Component } from 'react';

class SmallLoader extends Component {
  render(){

    return(
      <div className="small-loader show">
        <i className="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i>
        <span className="sr-only">Loading...</span>
      </div>
    );
  }
}
export default SmallLoader;


// WEBPACK FOOTER //
// ./src/components/pieces/SmallLoader.js